import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

/**
 * 设备服务
 */
export class DeviceServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 所有数据
  public getDeviceInfoAllData(opts: object) {
    const url = serverUrl + '/api/yunnan/device-info/list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 分页查询所有数据
  public getDeviceInfoPage(opts: object) {
    const url = serverUrl + '/api/yunnan/device-info';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 通过主键查询单条数据
  public getDeviceInfoDetail(id: any) {
    const url = serverUrl + '/api/yunnan/device-info/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 获取固定资产分类
  public getDeviceType(name: any) {
    const url = serverUrl + '/api/yunnan/device-info/group/' + name;
    return this.rSerivce.serverObj.get(url);
  }

  // 获取绑定设备危险点风险源数据
  getBindDevice(deviceGuid: any) {
    const url = serverUrl + '/api/yunnan/device-info/expand/' + deviceGuid;
    return this.rSerivce.serverObj.get(url);
  }

  // 获取绑定设备危险点风险源数据
  bindDevice(deviceGuid: any, opts: any) {
    const url = serverUrl + '/api/yunnan/device-info/expand/' + deviceGuid;
    return this.rSerivce.serverObj.post(url, opts);
  }

  // -------- ▼ 设备系统拓展数据 ▼ --------
  // 设备标点
  public devicePoint(opts: object) {
    const url = serverUrl + '/api/yunnan/device-info/expand/point';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // -------- ▲ 设备系统拓展数据 ▲ --------

  // -------- ▼ 设备数据 ▼ --------
  // 删除数据
  public deleteDevice(deviceGuid: any) {
    const url = serverUrl + '/api/yunnan/device-info/' + deviceGuid;
    return this.rSerivce.serverObj.delete(url);
  }

  // 创建设备
  addDevice(opts: any) {
    const url = serverUrl + '/api/yunnan/device-info';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editDevice(deviceGuid: string, opts: object) {
    const url = serverUrl + `/api/yunnan/device-info/${deviceGuid}`;
    return this.rSerivce.serverObj.put(url, opts);
  }
  // -------- ▲ 设备数据 ▲ --------
}
